import React from 'react';

export default function ProcessingTitle(props: any) {
  const renderSwitch = (param: any) => {
    switch (param) {
      case 'waiting':
        return '';
      case 'processing':
        return 'در حال پردازش';
      case 'uploading':
        return 'در حال بارگذاری';
      case 'faceNetProcessing':
        return 'در حال پردازش';
      case 'detectedCamera':
        return 'در حال بررسی دوربین';
      default:
        return '';
    }
  };
  return <>{renderSwitch(props.value)}</>;
}
